import type { FC } from "react";
import type { Size } from "../helpers/helpers.js";
import { SlideoverContainer } from "./slideoverContainer.js";
import {
  SlideoverDialog,
  SlideoverDialogButtons,
  SlideoverDialogContent,
  SlideoverDialogTitleHeader,
} from "./slideoverDialog.js";

interface SlideoverProps {
  onClose: () => void;
  shouldShow: boolean;
  children: React.ReactNode;
  buttons?: React.ReactNode;
  title: string;
  /** Size of the slideover panel */
  size?: Size;
}

/**
 * @deprecated Use `SlideoverContainer` with `SlideoverDialog` moving forward.
 *
 * Rendering the slideover (using `SlideoverContainer`) and its content (using `SlideoverDialog`) separately allows the slideover to always be mounted while the content automatically unmounts when the slideover closes. This makes animations work without having to deal with resetting the state of forms inside the slideover.
 */
export const Slideover: FC<SlideoverProps> = ({
  onClose,
  title,
  children,
  buttons,
  shouldShow,
  size,
}) => {
  return (
    <SlideoverContainer
      size={size}
      isDismissable
      isOpen={shouldShow}
      onOpenChange={(newIsOpen) => {
        if (!newIsOpen) {
          onClose();
        }
      }}
    >
      <SlideoverDialog label={title}>
        <SlideoverDialogTitleHeader isLoading={false}>
          {title}
        </SlideoverDialogTitleHeader>

        <SlideoverDialogContent>{children}</SlideoverDialogContent>

        {buttons && <SlideoverDialogButtons>{buttons}</SlideoverDialogButtons>}
      </SlideoverDialog>
    </SlideoverContainer>
  );
};
